import { useAtomValue } from 'jotai'
import { useTimeSpanGroupedHistory } from '@/src/queries/hooks/history'
import { accountsAddressesAtom } from '@/src/stores/accounts/atoms'

/**
 * Hook to detect pending trades from history.
 * Uses the same logic as the activity tab to check for running trades.
 */
export const usePendingTrades = () => {
  const accountsAddresses = useAtomValue(accountsAddressesAtom)

  // Skip pending trade checks in e2e test mode to prevent test flakiness
  // Tests can get stuck when previous test runs leave trades in "running" state
  const isE2eTestMode =
    typeof window !== 'undefined' &&
    window.localStorage.getItem('e2eTestMode') === 'true'

  const { data: groupedActivity } = useTimeSpanGroupedHistory({
    wallets: accountsAddresses,
    hideExpired: true,
    enabled: accountsAddresses.length > 0 && !isE2eTestMode,
  })

  if (isE2eTestMode) {
    return {
      hasPendingTrade: false,
      firstPendingRoute: undefined,
      pendingRoutes: [],
    }
  }

  // Find pending trades (same logic as activity tab)
  const pendingRoutes = groupedActivity?.filter((item) => {
    if (typeof item === 'string') return false
    return item.isRunning && !item.isSuccessful && !item.isFailed
  })

  const firstPendingRoute = pendingRoutes?.[0]
  const hasPendingTrade = (pendingRoutes?.length ?? 0) > 0

  return {
    hasPendingTrade,
    firstPendingRoute:
      typeof firstPendingRoute !== 'string' ? firstPendingRoute : undefined,
    pendingRoutes,
  }
}
